import { DEFAULT_LANG } from '@/config'

export default {
  adminLoggedInfo: null,
  isVerifying: false,
  lang: DEFAULT_LANG,
  unreadNotificationList: {
    parentNotificationIds: [],
    parentUpdateHistoryIds: [],
    busNotificationIds: [],
    cancelIds: [],
    authorizedPersonIds: [],
    parentApproveIds: [],
    newStudentNoticeIds: []
  }
}
